import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateRfpProposalsInput,
    RfpProposals,
    UpdateRfpProposalsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class RfpPorposalsService {
    private amplifyClient = generateClient();

    constructor() {}

    async listRfpProposals(): Promise<RfpProposals[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfpProposals
                })
            ).data.listRfpProposals.items;
            if (data) return data as RfpProposals[];
        } catch (error) {
            console.error('Error finding RfpProposals:', error);
            return null;
        }
    }

    async createRfpProposals(
        input: CreateRfpProposalsInput
    ): Promise<RfpProposals> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createRfpProposals,
                    variables: {
                        input
                    }
                })
            ).data.createRfpProposals;
            if (data) return data as RfpProposals;
        } catch (error) {
            console.error('Error creating RfpProposals:', error);
            return null;
        }
    }
    async updateRfpProposals(
        input: UpdateRfpProposalsInput
    ): Promise<RfpProposals> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateRfpProposals,
                    variables: {
                        input
                    }
                })
            ).data.updateRfpProposals;
            if (data) return data as RfpProposals;
        } catch (error) {
            console.error('Error updated RfpProposals:', error);
            return null;
        }
    }
}
